// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"47988ff6a98c1f589cf4","117":"3f1fa9b99fcb932f1f9f","118":"43639f2c425f70ba0da0","166":"656eaffdb2cda183d85a"}[chunkId] + ".chunk.js";
};